// Yandex Maps key. Set VITE_YANDEX_MAPS_API_KEY in .env (or the deploy environment).
export const YANDEX_MAPS_API_KEY: string = import.meta.env.VITE_YANDEX_MAPS_API_KEY ?? ''

if (!YANDEX_MAPS_API_KEY && import.meta.env.DEV) {
  console.warn('VITE_YANDEX_MAPS_API_KEY is not set: Yandex maps will not load.')
}
